import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    ErrorDisclaimer: {
        width: '100%',
        minHeight: '40vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    ErrorDisclaimerContainer: {
        background: '#ffffff',
        padding: '4rem 4rem',
        borderRadius: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '2.5rem',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
    },
    ErrorDisclaimerText: {
        fontSize: '1.2rem',
        fontWeight: '800',
    },
    ErrorDisclaimerButtonsContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap-reverse',
        gap: '1rem',
        borderTop: `1px solid ${theme.palette.lightGrey.half}`,
        paddingTop: '2rem',
    },
    ErrorDisclaimerIconContainer: {
        borderRadius: '100px',
        background: theme.palette.red.shadow,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
    },
    ErrorDisclaimerIcon: {
        width: '4rem',
        height: '4rem',
        color: theme.palette.red.main,
    },
}))
